var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filterOrderFilters.length >= 1
    ? _c(
        "div",
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c("el-col", { attrs: { xs: 24, sm: 22, md: 22, lg: 22 } }, [
                _c(
                  "div",
                  { staticClass: "order-filter-tag" },
                  _vm._l(_vm.filterOrderFilters, function (filter, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticClass: "filter-tag",
                        attrs: { closable: "", size: "mini" },
                        on: {
                          close: function ($event) {
                            return _vm.handleCloseTag(filter)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("planning.columns." + filter.label)) +
                            ": " +
                            _vm._s(filter.value.replace(/\~/g, ", ")) +
                            " "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ]),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 2, md: 2, lg: 2 } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("planning.removeOrderFilters"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "small" },
                          on: { click: _vm.removeOrderFilters },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "backspace", "aria-hidden": "true" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }